import type { FaireProductEntity } from "../../entity_types/product";

export const p_up34at3585: FaireProductEntity = {
  token: "p_up34at3585",
  type: "product",
  name: "Slouchy Versatile Long Knit Cardigan",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/41898d372d2521b203da984928821a9c7a1775eb42556a18022d6789bf8a74a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf898d005c0700529ad3c40e832617be0f1ad1b8b8747970d12f77eb85026411.jpeg",
    "https://cdn.faire.com/fastly/d5e25c0f5aa35dbea11c716c881c9e7a84479abd2c9e685161df373fa0ab0d6a.jpeg",
    "https://cdn.faire.com/fastly/1dbe0f8773b7fa3609fa9ca26c163918207b77eccd937c3daa040dcdfcde4cd8.jpeg",
    "https://cdn.faire.com/fastly/a8941aa6f17986a6688f73cb47500c9fa9a1151ea27986ea4b0b40cd83094752.jpeg",
    "https://cdn.faire.com/fastly/61f0992980c1c206d9448bcc3e0bfd1df568ac64cb2010743b5ea3feaf22cbeb.jpeg",
    "https://cdn.faire.com/fastly/0fc8af8796baf741211d73d6baf94f8c7d29ac67913309b8ec57cae53b882651.jpeg",
    "https://cdn.faire.com/fastly/2d67faf1035d799834e9980d5ffdde4079cc3ad25e9a40aa8bfdb62ae1c5cbe7.jpeg",
    "https://cdn.faire.com/fastly/863045046326def0a74f942cbcf5ee993dc9c7fc20c541276416d08bb3ad9d02.jpeg",
    "https://cdn.faire.com/fastly/a9db07241f5aee58e968b9c2daa0b997e6f549d9b85e55793efd8ce8c90d1c51.jpeg",
    "https://cdn.faire.com/fastly/d13f2a13cc5d3072513467c9bdd15fca74544e4ac4bef211de1bd3a5e46d39f6.jpeg",
    "https://cdn.faire.com/fastly/b50992fd658c9db4a41e34a6fafb641cb3c053056c392fdb2ecfbf875842b89f.jpeg",
    "https://cdn.faire.com/fastly/94be8812f58c7f7b29ea759f127b19d82b2f0dbd7fc753d51480dd0eab121f4d.jpeg",
    "https://cdn.faire.com/fastly/a2138f076d0cbb15dc9aa2126270148f6c6a7bdb6df2a0c20a85e0f526aa4dd7.jpeg",
    "https://cdn.faire.com/fastly/6bba852921f20fe61f53171d2d1f290511862cd065fe1f0b8307d53973508d9c.jpeg",
    "https://cdn.faire.com/fastly/63e859bce58943207d0f2f5e9ae73fe30f57d4ab3244917a4afc5de27b37c8b6.jpeg",
    "https://cdn.faire.com/fastly/8096b4ea6b3aefd6fd691262f91c19241f046c9d3855dedffc34c74edbf68096.jpeg",
    "https://cdn.faire.com/fastly/21f6bef7165aa8972607bc62d3cdfec1fdffb7ec9dee8847de5b73f682e72a61.jpeg",
    "https://cdn.faire.com/fastly/c4172d5ff311ed6cfe3d0fceda0461d77cd2219f46dc6bb2e1a62c04e6d2d8d8.jpeg",
    "https://cdn.faire.com/fastly/ca4c436d3e3ccc11c79fc8cd886a8a63fdeacdc4a0d5a474f2f6c8f01e7d516c.jpeg",
  ],
  priceDollars: 24.09,
  description:
    "SLOUCHY VERSATILE LONG KNIT CARDIGAN_RCXL06012\n\n\tSize Chart(Inch)\t\t\t\n\t\tChest\tSleeve\tLength\t\n\tS\t 40.16 \t 16.14 \t 35.43 \n\tM\t 41.73 \t 16.54 \t 35.83 \n\tL\t 43.31 \t 16.93 \t 36.22 \n\tXL\t 44.88 \t 17.32 \t 36.61 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2025 Women Apparel",
  tags: [],
  msrpDollars: 48.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:40.362Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
